export const COLLECTION_INTENTS = {
	ADD_IMAGES: 'add-images',
	REMOVE_IMAGE: 'remove-image',
	MOVE_IMAGE: 'move-image',
	PUBLISH: 'publish',
	UNPUBLISH: 'unpublish',
	CHANGE_TYPOLOGY: 'change-typology',
	EDIT_COLORS: 'edit-colors',
	CHANGE_NAME: 'change-name',
	EDIT_DESCRIPTION: 'edit-description',
	EDIT_BACKGROUND_COLOR: 'edit-background-color',
	EDIT_MODIFIERS: 'edit-modifiers',
	EDIT_COLLECTIONS: 'edit-collections',
	NEW_VARIANTS: 'create-variants',
	EDIT_VARIANT: 'edit-variant',
	DELETE_VARIANT: 'delete-variant',
	CHANGE_AMBIENT_CONFIGURATION: 'change-ambient-configuration',
	DELETE: 'delete',
}

export enum AMBIENT_CONFIGURATIONS {
	'0_NONE' = 'none',
	'1_RIGHT' = 'one_right',
	'1_CENTER_LEFT' = 'one_center_left',
	'2_VER_HOR' = 'two_vertical_horizontal',
	'3_BALANCED' = 'three_balanced',
	'4_LEFT' = 'four_left',
}

export enum CONTINUITY_OPTIONS {
	'NONE' = 'none',
	'HORIZONTAL' = 'horizontal',
	'VERTICAL' = 'vertical',
	'INFINITE' = 'infinite',
}
